import axios from "axios";

//Create Roles
export const createRole = async (req) => {
  try {
    const response = await axios.post(
      `/rolesPermissions`,
      {
        req
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating role", error);
  }
  return createRole;
};
//get Roles

export const getRoles = async () => {
  try {
    const response = await axios.get(`/rolesPermissions`);
    if (!response) {
      console.log("error in fetching data");
    }

    return response.data;
  } catch (error) {
    console.error(error);
  }
  return getRoles;
};

export const getRolePermissionDetailsById = async (roleId) => {
  try {
    const response = await axios.get(`/rolesPermissions/${roleId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching role:", {
      error: error.response?.data || error.message,
      status: error.response?.status,
    });
    throw new Error(error.response?.data?.message || "Failed to fetch role details");
  }
};

export const updateRole = async (roleId, roleData) => {
  try {
    const response = await axios.put(
      `/rolesPermissions/${roleId}`,
      { roleData }, // Wrap in roleData object
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error("Update Role Error:", error.response?.data || error.message);
    throw new Error(
      error.response?.data?.message || 
      "Failed to update role"
    );
  }
};


//Delete Roles

export const deleteRole = async (roleId) => {
  try {
    const response = await axios.delete(
      `/rolesPermissions/${roleId}`
    );
    console.log(response.data, "response deleteRole API");
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Failed to delete role");
  }
};



export const getModules = async () => {

  try {
    const response = await axios.get(
        "/modules"
    );
    console.log(response.data, "id");
    return response.data;
  } catch (error) {
    console.error(error);
  }
};